import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import 'antd/dist/antd.css';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';

export class GroupStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      groups: [],
      groupsList: [],
      groupscms: [],
      groupInfo: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
      tenantIds: null,
      groupId: null,
      groupName: '',
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.tenantIds = null;
    this.groupscms = [];
  }

  resetGroups() {
    this.groups = [];
  }

  async setData(task, data, getGroup = true) {
    this[task] = data;
    if (getGroup) {
      this.getGroupCMSList(this.offset, this.limit, this.search, this.sort, this.order, this.tenantIds);
    }
  }

  async getGroupCMSList(offset = 0, limit = 15, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/group/cms/list`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const groups = res.body || {};
        this.groupscms = groups;
        return this.groupscms;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getGroupList(tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    try {
      let url = `${config.api.url}/${config.api.version}/group`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const groups = res.body || {};
        this.groups = groups;
        return groups;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getGroupListByPermission(tenantIds = null, groupPermission = null) {
    this.loading = true;
    let queryOption = {};
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    try {
      let url = `${config.api.url}/${config.api.version}/group`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let groups = res.body || {};
        if (groupPermission) {
          groups = groups.filter((g) => groupPermission.includes(g.id));
        }
        this.groups = groups;
        return this.groups;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getGroupById(id) {
    this.loading = true;
    try {
      const res = await rp
        .get(`${config.api.url}/${config.api.version}/group/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const groups = res.body || {};
        return groups;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getGroupListByLocationIds(ids) {
    this.loading = true;
    try {
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/group/locations`, {
          body: {
            locationIds: ids,
          },
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const groups = res.body || {};
        this.groups = groups;
        return this.groups;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getGroupByLocationId(id) {
    this.loading = true;
    try {
      const res = await rp
        .get(`${config.api.url}/${config.api.version}/group/location/${id}`, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const groupsList = res.body || {};
        this.groupsList = groupsList;
        return this.groupsList;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createGroup(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        floor: data.floor,
        locationId: data.locationId,
        tenantId: data.tenantId,
        description: data.description,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/group`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateGroup(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        floor: data.floor,
        locationId: data.locationId,
        tenantId: data.tenantId,
        description: data.description,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/group/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateGroups(data) {
    this.loading = true;
    try {
      const detail = {
        tenantId: data.tenantId,
        groups: data.organizations,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/group/update/current`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteGroup(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/group/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async unassignGroup(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/group/unassign/location/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new GroupStore();
